/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarcatoreCorpoAbilitatoDto } from '../../models/marcatore-corpo-abilitato-dto';

export interface ApiMarcatoreMarcatoreCorpiAbilitatiGet$Params {}

export function apiMarcatoreMarcatoreCorpiAbilitatiGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiMarcatoreMarcatoreCorpiAbilitatiGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<MarcatoreCorpoAbilitatoDto>>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreMarcatoreCorpiAbilitatiGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<MarcatoreCorpoAbilitatoDto>>;
        }),
    );
}

apiMarcatoreMarcatoreCorpiAbilitatiGet.PATH = '/api/marcatore/marcatore-corpi-abilitati';
